import { h, Component } from 'preact';
import s from 'components/bolt/downWorld/bricks/bricks.sss';
import { joinClasses } from 'utils/utils';
import Store from 'store/store';

export default class Bricks extends Component {

	constructor(props) {
		super(props);
		this.$video0;
		this.$video1;
		this.$video2;

		this.playVideo = this.playVideo.bind(this);
		this.onEnded = this.onEnded.bind(this);
		this.onPause = this.onPause.bind(this);
		this.reset = this.reset.bind(this);

		this.state = {
			videoState: 0,
			videoActive: false
		};

		this.videos = ['nh3szp', 'jn8dx2', 'ghc1xa', 'ghc1xa'];

		this.videoStates = [
			{
				video: '$video0',
				videoFlipped: false,
				onPlay: 'resetScroll',
			},
			{
				video: '$video1',
				videoFlipped: false,
				onPlay: 'resetScroll',
			},
			{
				video: '$video2',
				videoFlipped: false,
				onPlay: 'toggleDownWorld',
			},
			{
				video: '$video3',
				videoFlipped: true,
				onPlay: 'toggleDownWorld',
			} 
		];
	}

	componentDidMount() {
		Store.on('PLAY_BRICKS_VIDEO', this.playVideo);
	}

	reset() {
		if (!this.state.videoActive) {
			this.setState({ videoState: 0 });
		}
	}

	onPause(id) {
		const video = this['$video' + id];
		if (video.currentTime < video.duration) {
			setTimeout(() => video.play(), 300);
		}
	}

	playVideo() {
		const { videoState } = this.state;

			
		const video = this[this.videoStates[videoState].video];
		if (!this.state.videoActive) {
			if (video) {
				this.setState({ videoActive: true });
				video.currentTime = 0;
				const brickAudioIndex = Math.min(videoState, 2);
				Store.emit('PLAY_SOUND', `brick${brickAudioIndex}`);
				video.play();
			}

			if (this.videoStates[videoState].onPlay == 'resetScroll') {
				this.props.resetScroll('smooth');
			} else if (this.videoStates[videoState].onPlay == 'toggleDownWorld') { 
				this.props.toggleDownWorld();
			}
		}
	}

	onEnded() {
		const { videoState } = this.state;
		this.setState({ videoActive: false, videoState: videoState >= this.videoStates.length - 1 ? 0 : videoState + 1 });
	}

	render() {
		const { videoRoot } = this.props;
		const { videoActive } = this.state;
		//const videoName = videoState && this.videoStates[videoState].video;

		return (
			<div class={s.container}>{ 
				this.videos.map((video, id) => {
					const videoState = this.videoStates[id];
					return (
						<video
							key={`bricks-video-${id}`}
							id={`bricks-video-${id}`}
							style={{ transform: `scale(${videoState.videoFlipped ? -1 : 1})` }}
							ref={video => this['$video' + id] = video} 
							muted
							playsinline 
							class={joinClasses(s.video, videoActive && s.active)} 
							onEnded={this.onEnded}
							onPause={() => this.onPause(id)}
						>	
							<source src={`${videoRoot}/down/${video}.mov`} type={'video/mp4; codecs="hvc1"'} />
							<source src={`${videoRoot}/down/${video}.webm`} type={'video/webm; codecs="vp9"'} />
						</video>
					);
				})
			}
			</div>
		);
	}
}

